import * as React from 'react';
import { useState } from 'react';
import { History } from 'history';
import Modal from '../../shared/Modal';
import { IAccountDetails } from '../../services/account';
import { defineMessages, FormattedMessage, injectIntl, InjectedIntlProps } from 'react-intl';
import { PAGE_CREATE_PATH } from '../../constants';
import DatabaseSelect from '../shared/DatabaseSelect';

interface ICreatePageModal { history: History, accountDetails: IAccountDetails, id?: string }
export default injectIntl((props: InjectedIntlProps & ICreatePageModal) => {
    const [selectedDatabaseName, setSelectedDatabaseName] = useState<string | null>(null);
    const [hasSubmitted, setHasSubmitted] = useState<boolean>(false);

    // has own databases or partners?
    // if so can add page
    // if no DB or partners
    // has subscription? can add DB
    // otherwise, no CTA

    const messages = defineMessages({
        serverError: {
            id: 'dash.page.add.err',
            defaultMessage: 'There was an error contacting the server. Please reload the page and try again.'
        },
        modalTitle: {
            id: 'dash.page.add.title',
            defaultMessage: 'Create Page'
        },
        cancelSendMessage: {
            id: 'dash.page.add.cancel',
            defaultMessage: 'Cancel'
        }
    });

    const renderDatabaseSelect = () => {
        return (
            // <FormattedMessage id="dash.page.add.err.nosub" defaultMessage="You have not joined any databases yet.">
            //     {(noDatabasesMessage: string) => (
            //         <FormattedMessage id="dash.msgs.send.dbselect" defaultMessage="Select a Database to Add a Page.">
            //             {(defaultMessage: string) => <DatabaseSelect
            //                 errorMessage={hasSubmitted && <FormattedMessage id="dash.page.add.dbselect.req" defaultMessage="You must select a database to create a page." />}
            //                 currentModalId={`#${props.id || 'createPageModal'}`}
            //                 onChange={setSelectedDatabaseName}
            //                 defaultMessage={defaultMessage}
            //                 canCreate={props.accountDetails.subscriptionLevel > 0}
            //                 noDatabasesMessage={noDatabasesMessage} />}
            //         </FormattedMessage>
            //     )
            //     }
            // </FormattedMessage>
            <DatabaseSelect
                errorMessage={hasSubmitted && "You must select a database to create a page."}
                currentModalId={`#${props.id || 'createPageModal'}`}
                onChange={setSelectedDatabaseName}
                defaultMessage={"Select a Database to Add a Page."}
                canCreate={props.accountDetails.subscriptionLevel > 0}
                noDatabasesMessage={"You must select a database to add a partner."} />
        )
    }

    const create = () => {
        if (!selectedDatabaseName) {
            setHasSubmitted(true);
            return
        }
        // @ts-ignore
        $(`#${props.id || 'createPageModal'}`).modal('hide');
        props.history.push(PAGE_CREATE_PATH(selectedDatabaseName))
    }

    const createPageButton = [
        <button type="button" className="primary " key="done-button" onClick={create} disabled={!selectedDatabaseName}>
            Create
        </button>
    ];

    return (
        <React.Fragment>
            <button
                // onClick={loadData}
                className="primary h3 px-3 py-2 m-0 mx-3 mt-3"
                data-toggle="modal"
                data-target={`#${props.id || 'createPageModal'}`}>
                <FormattedMessage id="dash.page.add.hdr" defaultMessage="Create Page">
                    {(text) => text}
                </FormattedMessage>
            </button>
            <Modal
                large
                id={`${props.id || 'createPageModal'}`}
                title={props.intl.formatMessage(messages.modalTitle)}
                actionButtons={createPageButton}>
                <div className="form-group md-form d-flex justify-content-center">
                    {renderDatabaseSelect()}
                </div>
            </Modal>
        </React.Fragment>
    );
});



// WEBPACK FOOTER //
// ./src/client/pages/CreatePageModal.tsx